import styled from "styled-components";

export const Container = styled.div`
  margin-top: 200px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 15px 0;

  .select-input {
    width: 200px;
  }

  p {
    font-size: 1.2rem;
  }

  form {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 0;

    button {
      border-radius: 10px;
    }
  }

  .items-container {
    padding: 30px 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    .items {
      p {
        margin: 0;
        font-size: 0.875rem;
      }
      display: flex;
      align-items: center;
      gap: 2px;
    }
  }
`;

export const NavWrapper = styled.main`
  padding-left: 24px;
  margin-top: 8px;
  margin-right: 24px;

  nav {
    display: flex;

    a {
      display: block;
      background: #f5f5f5;
      padding: 4px 8px;
      color: #999999;
      border-radius: 8px 8px 0 0;
      transition: all ease 0.2s;

      &.current {
        background: #ab92bf;
        color: #ffffff;
      }

      &:hover {
        filter: brightness(0.8);
      }
    }
  }
`;
